import ProfileImageSetting from './ProfileImageSetting';
export default ProfileImageSetting;
